import React from 'react';

import SharedTestimonials, { TestimonialsProps } from './SharedTestimonials';

const TalkspaceTestimonials: React.FC<TestimonialsProps> = ({ setShowTestimonials }) => {
  const testimonials = [
    {
      background: '#f4a261',
      textColor: '#2e1c5b',
      boldText:
        '“My quality of life has improved thanks to Talkspace and [the] quality of therapy sessions. I would highly recommend them to anyone looking for positive experience with talk therapy.”',
      lightText: 'James',
    },
    {
      background: '#F9BEC8',
      textColor: '#2e1c5b',
      boldText:
        '“Talkspace felt life saving this year. I loved the ability to use the messaging sessions for the challenges I experienced in between my video sessions with my therapist.”',
      lightText: 'Sera',
    },
  ];

  return (
    <SharedTestimonials
      brand="talkspace"
      testimonials={testimonials}
      setShowTestimonials={setShowTestimonials}
      backgroundColor="#fdf1bd"
      showEllipses
    />
  );
};

export default TalkspaceTestimonials;
